module.exports = __webpack_public_path__ + "img/8.93456d7a.png";